import React, { useState, useCallback } from "react";
import { useHttpClient } from "shared/hooks/http-hook";
import Button from "shared/components/FormElements/Button";
import Grid from "@mui/material/Grid";

const STATE_OPTIONS = [
  "", "AL", "AK", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FL", "GA", "HI", "ID", "IL", "IN", "IA",
  "KS", "KY", "LA", "ME", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH", "NJ", "NM",
  "NY", "NC", "ND", "OH", "OK", "OR", "PA", "RI", "SC", "SD", "TN", "TX", "UT", "VT", "VA", "WA",
  "WV", "WI", "WY",
];

const LeadForm = ({ onCancel, onCreated }) => {
  const { sendRequest } = useHttpClient();
  const [companyName, setCompanyName] = useState("");
  const [website, setWebsite] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [usdot, setUsdot] = useState("");
  const [state, setState] = useState("");
  const [city, setCity] = useState("");
  const [notes, setNotes] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = useCallback(async (e) => {
    e.preventDefault();
    if (!companyName.trim()) {
      setError("Company name is required");
      return;
    }
    if (!website.trim() && !phone.trim() && !usdot.trim()) {
      setError("Provide a website, phone, or USDOT number");
      return;
    }

    setSubmitting(true);
    setError("");

    try {
      await sendRequest(
        `${process.env.REACT_APP_BACKEND_URL}/admin/lead-hunter/leads`,
        "POST",
        JSON.stringify({
          companyName,
          website,
          email,
          phone,
          usdot,
          country: "US",
          state,
          city,
          notes,
        }),
      );
      window.toast.success("Lead created and auto-processed");
      onCreated();
    } catch (err) {
      const msg = err?.message || "Failed to create lead";
      setError(msg);
      window.toast.error(msg);
    }
    setSubmitting(false);
  }, [sendRequest, companyName, website, email, phone, usdot, state, city, notes, onCreated]);

  const inputStyle = { width: "100%", padding: "8px", borderRadius: "4px", border: "1px solid #ccc" };
  const labelStyle = { fontSize: "13px", color: "#666", marginBottom: "4px", display: "block" };

  return (
    <div>
      <div style={{ marginBottom: "16px", display: "flex", alignItems: "center", gap: "12px" }}>
        <Button onClick={onCancel} size="small" inverse>Back</Button>
        <h3 style={{ margin: 0 }}>New US School Bus Lead</h3>
      </div>

      <form onSubmit={handleSubmit}>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <label style={labelStyle}>Company Name *</label>
            <input value={companyName} onChange={(e) => setCompanyName(e.target.value)} style={inputStyle} placeholder="ABC School Bus Inc" />
          </Grid>
          <Grid item xs={12} sm={6}>
            <label style={labelStyle}>Website URL</label>
            <input value={website} onChange={(e) => setWebsite(e.target.value)} style={inputStyle} placeholder="https://example.com" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <label style={labelStyle}>Email</label>
            <input value={email} onChange={(e) => setEmail(e.target.value)} style={inputStyle} placeholder="owner@example.com" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <label style={labelStyle}>Phone</label>
            <input value={phone} onChange={(e) => setPhone(e.target.value)} style={inputStyle} placeholder="(555) 555-1234" />
          </Grid>
          <Grid item xs={12} sm={4}>
            <label style={labelStyle}>USDOT</label>
            <input value={usdot} onChange={(e) => setUsdot(e.target.value)} style={inputStyle} placeholder="1234567" />
          </Grid>
          <Grid item xs={6} sm={3}>
            <label style={labelStyle}>State</label>
            <select value={state} onChange={(e) => setState(e.target.value)} style={inputStyle}>
              <option value="">Select</option>
              {STATE_OPTIONS.filter(Boolean).map((s) => (
                <option key={s} value={s}>{s}</option>
              ))}
            </select>
          </Grid>
          <Grid item xs={6} sm={3}>
            <label style={labelStyle}>City</label>
            <input value={city} onChange={(e) => setCity(e.target.value)} style={inputStyle} placeholder="Albany" />
          </Grid>
          <Grid item xs={12}>
            <label style={labelStyle}>Notes</label>
            <textarea value={notes} onChange={(e) => setNotes(e.target.value)} rows={3} style={{ ...inputStyle, resize: "vertical" }} />
          </Grid>
        </Grid>

        {error && <p style={{ color: "#d32f2f", marginTop: "8px" }}>{error}</p>}

        <div style={{ marginTop: "16px", display: "flex", gap: "8px" }}>
          <Button type="submit" disabled={submitting}>{submitting ? "Creating..." : "Create Lead"}</Button>
          <Button onClick={onCancel} inverse>Cancel</Button>
        </div>
      </form>
    </div>
  );
};

export default LeadForm;
